import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { PromiseHelper } from "../common/Exports";
export var ReplayableAudioNode = /*#__PURE__*/function () {
  function ReplayableAudioNode(audioSource, bytesPerSecond) {
    var _this = this;

    _classCallCheck(this, ReplayableAudioNode);

    this.privBuffers = [];
    this.privReplayOffset = 0;
    this.privLastShrinkOffset = 0;
    this.privBufferStartOffset = 0;
    this.privBufferSerial = 0;
    this.privBufferedBytes = 0;
    this.privReplay = false;
    this.privLastChunkAcquiredTime = 0;

    this.id = function () {
      return _this.privAudioNode.id();
    };

    this.privAudioNode = audioSource;
    this.privBytesPerSecond = bytesPerSecond;
  } // Reads and returns the next chunk of audio buffer.
  // If replay of existing buffers are needed, read() will first seek and replay
  // existing content, and upoin completion it will read new content from the underlying
  // audio node, saving that content into the replayable buffers.


  _createClass(ReplayableAudioNode, [{
    key: "read",
    value: function read() {
      var _this2 = this;

      // if there is a replay request to honor.
      if (!!this.privReplay && this.privBuffers.length !== 0) {
        // Find the start point in the buffers.
        // Offsets are in 100ns increments.
        // So how many bytes do we need to seek to get the right offset?
        var offsetToSeek = this.privReplayOffset - this.privBufferStartOffset;
        var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);

        if (0 !== bytesToSeek % 2) {
          bytesToSeek++;
        }

        var i = 0;

        while (i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength) {
          bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
        }

        var retVal = this.privBuffers[i].chunk.buffer.slice(bytesToSeek);
        this.privReplayOffset += retVal.byteLength / this.privBytesPerSecond * 1e+7; // If we've reached the end of the buffers, stop replaying.

        if (i === this.privBuffers.length - 1) {
          this.privReplay = false;
        }

        return PromiseHelper.fromResult({
          buffer: retVal,
          isEnd: false,
          timeReceived: this.privBuffers[i].chunk.timeReceived
        });
      }

      return this.privAudioNode.read().onSuccessContinueWith(function (result) {
        if (result && result.buffer) {
          _this2.privBuffers.push(new BufferEntry(result, _this2.privBufferSerial++, _this2.privBufferedBytes));

          _this2.privBufferedBytes += result.buffer.byteLength;
        }

        return result;
      });
    }
  }, {
    key: "detach",
    value: function detach() {
      this.privAudioNode.detach();
      this.privBuffers = undefined;
    }
  }, {
    key: "replay",
    value: function replay() {
      if (this.privBuffers && 0 !== this.privBuffers.length) {
        this.privReplay = true;
        this.privReplayOffset = this.privLastShrinkOffset;
      }
    } // Shrinks the existing audio buffers to start at the new offset, or at the
    // beginning of the buffer closest to the requested offset.
    // A replay request will start from the last shrink point.

  }, {
    key: "shrinkBuffers",
    value: function shrinkBuffers(offset) {
      if (this.privBuffers === undefined) {
        return;
      }

      this.privLastShrinkOffset = offset; // Find the start point in the buffers.
      // Offsets are in 100ns increments.
      // So how many bytes do we need to seek to get the right offset?

      var offsetToSeek = offset - this.privBufferStartOffset;
      var bytesToSeek = Math.round(offsetToSeek * this.privBytesPerSecond * 1e-7);
      var i = 0;

      while (i < this.privBuffers.length && bytesToSeek >= this.privBuffers[i].chunk.buffer.byteLength) {
        bytesToSeek -= this.privBuffers[i++].chunk.buffer.byteLength;
      }

      this.privBufferStartOffset = Math.round(offset - bytesToSeek / this.privBytesPerSecond * 1e+7);
      this.privBuffers = this.privBuffers.slice(i);
    } // Finds the time a buffer of audio was first seen by offset.

  }, {
    key: "findTimeAtOffset",
    value: function findTimeAtOffset(offset) {
      if (offset < this.privBufferStartOffset || this.privBuffers === undefined) {
        return 0;
      }

      var _iterator = _createForOfIteratorHelper(this.privBuffers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          var startOffset = value.byteOffset / this.privBytesPerSecond * 1e7;
          var endOffset = startOffset + value.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;

          if (offset >= startOffset && offset <= endOffset) {
            return value.chunk.timeReceived;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return 0;
    }
  }]);

  return ReplayableAudioNode;
}(); // Primary use of this class is to help debugging problems with the replay
// code. If the memory cost of alloc / dealloc gets too much, drop it and just use
// the ArrayBuffer directly.
// tslint:disable-next-line:max-classes-per-file

var BufferEntry = function BufferEntry(chunk, serial, byteOffset) {
  _classCallCheck(this, BufferEntry);

  this.chunk = chunk;
  this.serial = serial;
  this.byteOffset = byteOffset;
};